import { template as template_bccc3f216f2c4d868257bea4f87a1b9e } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { service } from '@ember/service';
import BsButton from 'eflex/components/bs-button';
import BsDropdown from 'ember-bootstrap/components/bs-dropdown';
import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import { t } from 'ember-intl';
import { fn } from '@ember/helper';
import { not, and, eq, or } from 'ember-truth-helpers';
import { ALLOWED_EXTENSIONS } from 'eflex/constants/file-types';
import FileInput from 'eflex/components/file-input';
import { task } from 'ember-concurrency';
import { waitFor } from '@ember/test-waiters';
import { on } from '@ember/modifier';
import { preventBubble } from 'eflex/helpers';
export default class WorkInstructionEditorActionDropdown extends Component {
    @service
    intl;
    @service
    currentUser;
    @service
    workInstructionRepo;
    supportedFileTypes = ALLOWED_EXTENSIONS;
    get targetIsMultiselected() {
        return this.args?.libraryItem?.isSelected && this.args.isMultiselectMode;
    }
    get useMultiselectActions() {
        return this.targetIsMultiselected || this.args.multiselectOnly;
    }
    get moveToDisabled() {
        return this.args.selectedCards.some((card)=>card?.isFolder);
    }
    get exportDisabled() {
        const onlyInstructionsSelected = this.args.selectedCards.every((card)=>card.canvas);
        const selectedAreViewOnly = !this.workInstructionRepo.userCanEditSelected(this.args.selectedCards);
        return !onlyInstructionsSelected || selectedAreViewOnly;
    }
    get replaceDisabled() {
        return !this.currentUser.user?.isUser || this.targetIsMultiselected;
    }
    _edit = task({
        drop: true
    }, waitFor(async (libraryItem, closeDropdown)=>{
        await this.args.edit(libraryItem);
        closeDropdown();
    }));
    _delete = task({
        drop: true
    }, waitFor(async (libraryItem, closeDropdown)=>{
        await this.args.delete(this.useMultiselectActions ? null : libraryItem);
        closeDropdown();
    }));
    _export = task({
        drop: true
    }, waitFor(async (libraryItem, fileType, closeDropdown)=>{
        await this.args.export(libraryItem, fileType);
        closeDropdown();
    }));
    _folderSettings = task({
        drop: true
    }, waitFor(async (libraryItem, closeDropdown)=>{
        await this.args.folderSettings(libraryItem);
        closeDropdown();
    }));
    _moveToFolder = task({
        drop: true
    }, waitFor(async (folder, libraryItem, closeDropdown)=>{
        await this.args.moveToFolder(folder, this.useMultiselectActions ? null : libraryItem);
        closeDropdown();
    }));
    _open = task({
        drop: true
    }, waitFor(async (libraryItem, closeDropdown)=>{
        await this.args.open(libraryItem);
        closeDropdown();
    }));
    static{
        template_bccc3f216f2c4d868257bea4f87a1b9e(`
    {{#unless @isReadOnly}}
      {{#let (if this.useMultiselectActions @selectedCards @libraryItem) as |selection|}}
        <BsDropdown
          @closeOnMenuClick={{false}}
          @direction={{if @isRow "left" "right"}}
          class="z-2"
          ...attributes
          as |dd|>
          <dd.toggle
            {{on "click" (preventBubble)}}
            {{on "dblclick" (preventBubble)}}
            class="btn-dropdown {{if @isRow "m-1"}}"
          >
            <BsButton
              @type={{@type}}
              @size="sm"
              class="border-1 {{if @isRow "d-flex align-items-center h-100"}}"
            >
              <FaIcon @icon="ellipsis" @prefix="fas" />
            </BsButton>
          </dd.toggle>

          <dd.menu
            class="dropdown-menu z-2"
            {{on "click" (preventBubble)}}
            {{on "dblclick" (preventBubble)}}
          as |menu|>
            {{#if this.useMultiselectActions}}
              <menu.item>
                <span class="dropdown-item fs-4 user-select-none bg-gray-200">
                  {{t "wieLibrary.itemsSelected" count=@selectedCards.length}}
                </span>
              </menu.item>
            {{/if}}
            {{#unless (and @libraryItem.isFolder this.useMultiselectActions) }}
              <div class="py-1 border-bottom border-gray-200">
                {{#if (and (not this.targetIsMultiselected) (not @libraryItem.isFolder) @edit)}}
                  <menu.item>
                    <BsButton
                      class="library-item-edit dropdown-item"
                      @size="sm"
                      @onClick={{fn this._edit.perform @libraryItem dd.closeDropdown}}
                    >
                      {{if @libraryItem.isInstruction (t "workInstruction.openInEditor") (t "open")}}
                    </BsButton>
                  </menu.item>
                {{/if}}
                {{#if (and @libraryItem.isFolder (not this.useMultiselectActions))}}
                  <menu.item>
                    <BsButton
                      class="library-item-open dropdown-item"
                      @size="sm"
                      @onClick={{fn this._open.perform @libraryItem dd.closeDropdown}}
                    >
                      {{t "workInstruction.openFolder"}}
                    </BsButton>
                  </menu.item>
                  <menu.item>
                    <BsButton
                      class="library-item-edit-folder dropdown-item"
                      @size="sm"
                      @onClick={{fn this._folderSettings.perform @libraryItem dd.closeDropdown}}
                    >
                      {{t "workInstructions.library.folderSettings"}}
                    </BsButton>
                  </menu.item>
                {{/if}}
                {{#if (and (or @libraryItem.isInstruction @multiselectOnly) @export)}}
                  <menu.item>
                    <BsDropdown
                      class="library-item-export z-top-menu {{if this.exportDisabled "pe-none"}}"
                      @direction="right"
                      @closeOnMenuClick={{false}}
                    as |subdd|>
                      <subdd.toggle class="text-decoration-none">
                        <BsButton
                          class="dropdown-item d-flex align-items-center"
                          @disabled={{this.exportDisabled}}
                          @size="sm"
                        >
                          {{if this.useMultiselectActions (t "wieLibrary.exportAll") (t "exportAs")}}
                          <FaIcon @icon="caret-right" @prefix="fas" class="ms-auto" />
                        </BsButton>
                      </subdd.toggle>
                      <subdd.menu
                        class="dropdown-menu export-menu"
                      as |submenu|>
                        <submenu.item class="dropdown-item" >
                          <BsButton
                            class="library-item-export-jpg dropdown-item"
                            @size="sm"
                            @onClick={{fn this._export.perform selection "image/jpeg" dd.closeDropdown}}
                          >
                            JPG
                          </BsButton>
                        </submenu.item>
                        <submenu.item class="dropdown-item">
                          <BsButton
                            class="library-item-export-pdf dropdown-item"
                            @size="sm"
                            @onClick={{fn this._export.perform selection "application/pdf" dd.closeDropdown}}
                          >
                            PDF
                          </BsButton>
                        </submenu.item>
                      </subdd.menu>
                    </BsDropdown>
                  </menu.item>
                {{/if}}
                {{#if (and (not @libraryItem.isFolder) @moveToFolder)}}
                  {{#if this.workInstructionRepo.folders.length}}
                    <menu.item>
                      <BsDropdown
                        class="library-item-move-to z-top-menu {{if this.moveToDisabled "pe-none"}}"
                        @direction="right"
                        @closeOnMenuClick={{false}}
                      as |subdd|>
                        <subdd.toggle class="text-decoration-none">
                          <BsButton
                            class="dropdown-item d-flex align-items-center"
                            @size="sm"
                            @disabled={{this.moveToDisabled}}
                          >
                            {{if this.useMultiselectActions (t "wieLibrary.moveAllTo") (t "moveTo")}}...
                            <FaIcon @icon="caret-right" @prefix="fas" class="ms-auto" />
                          </BsButton>
                        </subdd.toggle>
                        <subdd.menu
                          class="dropdown-menu move-to-menu eflex-scroll"
                        as |submenu|>
                          {{#if @selectedFolder}}
                            <submenu.item class="dropdown-item">
                              <BsButton
                                class="library-item-folder dropdown-item"
                                @size="sm"
                                @onClick={{fn this._moveToFolder.perform null selection dd.closeDropdown}}
                              >
                                /
                              </BsButton>
                            </submenu.item>
                          {{/if}}
                          {{#each this.workInstructionRepo.folders as |folder|}}
                            {{#unless (eq @selectedFolder folder)}}
                              <submenu.item class="dropdown-item">
                                <BsButton
                                  class="library-item-folder dropdown-item text-truncate"
                                  @size="sm"
                                  @onClick={{fn this._moveToFolder.perform folder selection dd.closeDropdown}}
                                >
                                  /{{folder.name}}
                                </BsButton>
                              </submenu.item>
                            {{/unless}}
                          {{/each}}
                        </subdd.menu>
                      </BsDropdown>
                    </menu.item>
                  {{/if}}
                {{/if}}
                {{#if (and @libraryItem.isFile @replace)}}
                  <menu.item>
                    <FileInput
                      @class="
                        library-item-replace btn btn-sm dropdown-item d-flex p-0 {{if this.replaceDisabled "pe-none"}}
                      "
                      accept={{this.supportedFileTypes}}
                      multiple={{false}}
                      @disabled={{this.replaceDisabled}}
                      @onChange={{@replace}}
                      @reference={{@libraryItem}}
                      @callback={{dd.closeDropdown}}
                    >
                      <BsButton
                        class="dropdown-item w-100"
                        @size="sm"
                        @disabled={{this.replaceDisabled}}
                      >
                        {{t "workInstructions.replace"}}...
                      </BsButton>
                    </FileInput>
                  </menu.item>
                {{/if}}
              </div>
            {{/unless}}
            <div class="py-1">
              <menu.item>
                <BsButton
                  class="library-item-delete dropdown-item text-danger"
                  @size="sm"
                  @onClick={{this._delete.perform selection dd.closeDropdown}}
                >
                  {{if this.useMultiselectActions (t "wieLibrary.deleteAll") (t "delete")}}
                </BsButton>
              </menu.item>
            </div>
          </dd.menu>
        </BsDropdown>
      {{/let}}
    {{/unless}}
    <div class="lightroom-bg pe-none rounded position-absolute top-0 w-100 h-100 bg-gray-900 bg-opacity-10" />
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    ;
}
